import { useHandleSearchParams } from "../../../_hooks";

export const useInitialized = () => {
	const {
		// 検索日
		searchDate,
		//
		// 検索日のセット
		onSetSearchDate,
	} = useHandleSearchParams();

	return {
		// 検索日
		searchDate,
		//
		// 検索日のセット
		onSetSearchDate,
	};
};
